import { currentLanguage } from 'src/i18n';
import type { SupportedLanguage } from 'src/i18n/types';
import { TEMPLATE_TRANSLATIONS } from 'src/i18n/template-content-data';

/**
 * Oversettelse av navn som stammer fra malen i dabih-api (issue #13272).
 *
 * Hovedmeny (pageGroups), sidetitler og navn på mal-entiteter (dokumenter,
 * retningslinjer osv.) leveres fra API-et som norske strenger. Vi oversetter dem
 * ved å slå opp det norske navnet i en generert nøkkel→oversettelse-tabell.
 *
 * Egendefinerte/bruker-skapte navn finnes ikke i tabellen og returneres som de
 * er — det er ønsket oppførsel: vi oversetter kun malinnhold, ikke brukerinnhold.
 * (Håndtering av brukerinnhold er et eget, åpent spørsmål.)
 */
export function translateTemplateName(name: string | null | undefined): string {
  if (!name) {
    return '';
  }
  const lang: SupportedLanguage = currentLanguage();
  if (lang === 'nb') {
    return name;
  }
  const entry = TEMPLATE_TRANSLATIONS[name.trim()];
  return entry?.[lang] ?? name;
}

/** Finnes det en mal-oversettelse for dette navnet? (nyttig for betinget UI/tester) */
export function hasTemplateTranslation(name: string | null | undefined): boolean {
  return !!name && name.trim() in TEMPLATE_TRANSLATIONS;
}
